import { createFileRoute } from '@tanstack/react-router'
import { PERMISSION_ROLES } from '../../../../../src/constants/premissions'
import { riskReportParamsSchema, riskReportSearchSchema } from '../../../../../src/schemas/routeSchemas'
import { requirePermission } from '../../../../../src/utils/routePermissions'

export const Route = createFileRoute('/v6/risk/report/$mmsi')({
  validateSearch: (search) => riskReportSearchSchema.parse(search),
  params: {
    parse: (params) => riskReportParamsSchema.parse(params),
  },
  loaderDeps: () => ({}),
  beforeLoad: ({ context }) => {
    requirePermission(context, Route.options.staticData?.permissionRequired)
  },
  staticData: {
    englishAllowed: true,
    permissionRequired: PERMISSION_ROLES.V6_RISK_REPORT,
  },
})
